<template>
  <div>
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" step="1">
          Información Básica
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="stepper > 2" step="2">
          Supervisores
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-progress-linear
            value="15"
            indeterminate
            absolute
            top
            v-if="this.$store.state.charge.isLoading"
          ></v-progress-linear>
          <v-form ref="formContract" v-model="formContract">
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="employee.colombian_id"
                    :rules="[this.$store.state.rules.required]"
                    label="Identificación"
                    append-outer-icon="mdi-account-search"
                    @click:append-outer="findEmployee('EMPLOYEE')"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="employee.full_name"
                    label="Nombre colaborador"
                    required
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.start_date"
                        label="Fecha de inicio"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.start_date"
                      @input="menuStartDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.end_date"
                        label="Fecha de finalización"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.end_date"
                      @input="menuEndDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="model.reports"
                    :rules="[this.$store.state.rules.required]"
                    label="Informes"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="model.monthly_salary"
                    :rules="[this.$store.state.rules.required]"
                    label="Salario Mensual"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="model.total_salary"
                    :rules="[this.$store.state.rules.required]"
                    label="Salario Total"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="model.duration"
                    :rules="[this.$store.state.rules.required]"
                    label="Duración (Meses)"
                    required
                  ></v-text-field>
                </v-col>
                
                 <v-col cols="12" md="4">
                             <v-select
           v-model="model.area"
                  :items="this.$store.state.areas.areas.data"
	item-text="nombre"
      item-value="id"
                  label="Area (opcional)"
                ></v-select>
                </v-col>
                
                
              </v-row>
            </v-container>
          </v-form>

          <v-btn color="primary" @click="nextStepSupervisor"> Continuar </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-data-table
            :headers="headers"
            :items="model.supervisors"
            class="elevation-1 mb-7"
            no-data-text="No hay registros agregados..."
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Supervisores</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- Dialog add supervisor -->
                <v-dialog v-model="dialogAddSupervisor" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Agregar
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline"
                        >{{ titleDialogSupervisor }} Supervisor</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-form ref="formSupervisor" v-model="formAddSupervisor">
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-select
                                :items="supervisorStatus"
                                v-model="modelSupervisor.type"
                                label="Tipo"
                              ></v-select>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="modelSupervisor.identification"
                                label="Identificación"
                                append-outer-icon="mdi-account-search"
                                @click:append-outer="findEmployee('SUPERVISOR')"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="modelSupervisor.full_name"
                                label="Nombre"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeSupervisor"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="saveSupervisor">
                        {{ titleDialogSupervisor }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- Dialog delete supervisor -->
                <v-dialog v-model="dialogDeleteSupervisor" max-width="550px">
                  <v-card>
                    <v-card-title class="headline"
                      >Seguro que desea eliminar este supervisor?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeDeleteSupervisor"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteSupervisorConfirm"
                        >Aceptar</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="green"
                    v-bind="attrs"
                    v-on="on"
                    @click="editSupervisor(item.item)"
                  >
                    <v-icon dark> mdi-circle-edit-outline </v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                    @click="deleteSupervisor(item.item)"
                  >
                    <v-icon dark> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-btn color="primary" @click="saveContract"> Guardar </v-btn>
          <v-btn text @click="stepper = 1"> Volver </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <!-- Dialog loader -->
    <v-dialog
      v-model="this.$store.state.contract.isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
import { SET_EMPLOYEES } from "@/store/employee/employees";
export default {
  name: "CreateContract",
  data: () => ({
    stepper: 1,
    formCharge: true,
    formContract: true,
    menuEndDate: null,
    menuStartDate: null,
    editedIndexAnnexe: -1,
    typeFindEmployee: null,
    currentSupervisor: null,
    formAddSupervisor: true,
    dialogAddSupervisor: false,
    dialogDeleteSupervisor: false,
    model: {
      start_date: "",
      end_date: "",
      reports: "",
      monthly_salary: "",
      total_salary: "",
      employee_id: "",
      supervisors: [],
      area: false,
    },
    employee: {
      colombian_id: "",
      full_name: "",
    },
    modelSupervisor: {
      full_name: "",
      identification: "",
      type: "",
      employee_id: "",
    },
    headers: [
      { text: "Nombre", value: "full_name", sortable: false },
      { text: "Identificación", value: "identification", sortable: false },
      { text: "Tipo", value: "type", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
  }),
  created() {
      this.$store.dispatch("getAreas");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_EMPLOYEES) {
        if (state.employee.employees.employees.data.length > 0) {
          this.currentEmployee = state.employee.employees.employees.data[0];

          if (this.typeFindEmployee == "EMPLOYEE") this.setDataEmployee();

          if (this.typeFindEmployee == "SUPERVISOR") this.setDataSupervisor();
        } else {
          if (this.typeFindEmployee == "EMPLOYEE") this.clearInputsEmployee();

          if (this.typeFindEmployee == "SUPERVISOR")
            this.clearInputsSupervisor();
        }
      }
    });
  },
  computed: {
    titleDialogSupervisor() {
      return this.currentAnnexe ? "Editar" : "Agregar";
    },
    supervisorStatus() {
      return this.$store.state.status.supervisorType;
    },
    monthly_salary() {
      return this.model.monthly_salary;
    },
    total_salary() {
      return this.model.total_salary;
    },
  },
  watch: {
    monthly_salary(val) {
      if (parseInt(val) > 0) {
        val = val.split(".").join("");
        this.model.monthly_salary = new Intl.NumberFormat("de-DE").format(val);
      }
    },
    total_salary(val) {
      if (parseInt(val) > 0) {
        val = val.split(".").join("");
        this.model.total_salary = new Intl.NumberFormat("de-DE").format(val);
      }
    },
  },
  methods: {
    async saveContract() {
      /* if (this.model.supervisors.length == 0) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar minimo un supervisor",
          type: "error",
        });
        return;
      } */
      this.setNumber();
      this.$store.dispatch("createContract", this.model);
    },
    findEmployee(type) {
      const id =
        type == "EMPLOYEE"
          ? this.employee.colombian_id
          : this.modelSupervisor.identification;
      this.typeFindEmployee = type;
      this.$store.dispatch("getEmployees", "colombian_id_by_id=" + id + "&");
    },
    nextStepSupervisor() {
      if (!this.$refs.formContract.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }

      this.stepper = 2;
    },
    editSupervisor(item) {
      this.editedIndexSupervisor = this.model.supervisors.indexOf(item);
      this.currentSupervisor = Object.assign({}, item);
      this.modelSupervisor = Object.assign({}, item);
      this.dialogAddSupervisor = true;
    },
    deleteSupervisor(item) {
      this.editedIndexSupervisor = this.model.supervisors.indexOf(item);
      this.currentSupervisor = Object.assign({}, item);
      this.dialogDeleteSupervisor = true;
    },
    deleteSupervisorConfirm() {
      this.model.Supervisors.splice(this.editedIndexSupervisor, 1);
      this.closeDeleteSupervisor();
    },
    closeSupervisor() {
      this.dialogAddSupervisor = false;
      this.$nextTick(() => {
        this.currentSupervisor = null;
        this.modelSupervisor = {
          name: "",
          identification: "",
          type: "",
        };
        this.editedIndexSupervisor = -1;
        this.$refs.formSupervisor.resetValidation();
      });
    },
    closeDeleteSupervisor() {
      this.dialogDeleteSupervisor = false;
      this.$nextTick(() => {
        this.currentSupervisor = null;
        this.editedIndexSupervisor = -1;
      });
    },
    saveSupervisor() {
      //Validate inputs
      if (
        this.modelSupervisor.type == "" ||
        this.modelSupervisor.employee_id == ""
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      //Validate if the employee is the headline of the contract
      /* if (this.model.employee_id == this.modelSupervisor.employee_id) {
        this.$store.commit(SET_ALERT, {
          message: "No puede agregar al titular del contrato como supervisor",
          type: "error",
        });
        return;
      } */
      //Validate if the supervisor is added
      if (
        this.model.supervisors.find(
          (obj) => obj.employee_id == this.modelSupervisor.employee_id
        )
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Este supervisor se encuentra agregado",
          type: "error",
        });
        return;
      }
      if (this.currentSupervisor) {
        Object.assign(
          this.model.supervisors[this.editedIndexSupervisor],
          this.modelSupervisor
        );
      } else {
        this.model.supervisors.push(this.modelSupervisor);
      }
      this.closeSupervisor();
    },
    setNumber() {
      if (typeof this.model.monthly_salary === "string")
        this.model.monthly_salary = this.model.monthly_salary
          .split(".")
          .join("");

      if (typeof this.model.total_salary === "string")
        this.model.total_salary = this.model.total_salary.split(".").join("");
    },
    setDataEmployee() {
      this.model.employee_id = this.currentEmployee.id;
      this.employee.full_name = this.currentEmployee.user.full_name;
    },
    clearInputsEmployee() {
      this.model.employee_id = "";
      this.employee.full_name = "";
    },
    setDataSupervisor() {
      this.modelSupervisor.employee_id = this.currentEmployee.id;
      this.modelSupervisor.full_name = this.currentEmployee.user.full_name;
    },
    clearInputsSupervisor() {
      this.modelSupervisor.employee_id = "";
      this.modelSupervisor.full_name = "";
    },
  },
};
</script>

<style>
</style>
